import 'whatwg-fetch';
import { browserHistory } from 'react-router';
import { getUserQuery } from './participant-action';

export const formSubmit = () => (
  (dispatch) => {
    dispatch({type: 'RESET_VALIDATION'});
    dispatch({type: 'FORM_SUBMIT'});
    setTimeout(() => {
      dispatch({type: 'AFTER_VALIDATE'});
    }, 500);
  }
);

export const postRegister = (regData) => (
  (dispatch) => {
    dispatch({type: 'RESET_VALIDATION'});
    fetch('/api/signup-submit.json', {
      method: 'post',
      body: regData
    })
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          dispatch({
            type: 'REGISTRATION_SUCCESS',
            successMessage: json.successMessage
          })
        } else {
          dispatch({
            type: 'ERRORS_FROM_SERVER',
            errors: json.errors
          });
        }
        window.scrollTo(0, 0);
      })
      .catch(err => {
        console.log(err)
      })
  }
);

export const postAuth = (authData) => (
  (dispatch) => {
    dispatch({type: 'RESET_VALIDATION'});
    fetch('/api/j_spring_security_check', {
      method: 'post',
      body: authData,
      credentials: 'include',
      headers: {
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
      }
    })
      .then(response => {
        if (response.ok) {
          dispatch({
            type: 'AUTH_SUCCESS'
          });
          getUserQuery(dispatch);
          browserHistory.push('/');
        } else {
          dispatch({
            type: 'AUTH_FAIL',
            failMessage: 'Email или пароль не верны.'
          });
          window.scrollTo(0, 0);
        }
      })
      .catch(err => {
        console.log(err)
      })
  }
);
export const postRestore = (regData) => (
  (dispatch) => {
    dispatch({type: 'RESET_VALIDATION'});
    fetch('/api/restore-password.json', {
      method: 'post',
      body: regData
    })
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          dispatch({
            type: 'RESTORE_SUCCESS',
            successMessage: json.successMessage
          })
        } else {
          dispatch({
            type: 'ERRORS_FROM_SERVER',
            errors: json.errors
          });
        }
        window.scrollTo(0, 0);
      })
      .catch(err => {
        console.log(err)
      })
  }
);

export const postSaveRestore = (regData) => (
  (dispatch) => {
    dispatch({type: 'RESET_VALIDATION'});
    fetch('/api/set-password.json', {
      method: 'post',
      body: regData
    })
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          dispatch({
            type: 'RESTORE_SAVE_SUCCESS',
            successMessage: json.successMessage
          })

        } else {
          if (json.errors) {
            dispatch({
              type: 'ERRORS_FROM_SERVER',
              errors: json.errors
            });
          } else {
            dispatch({
              type: 'RESTORE_SAVE_FAIL',
              message: 'Возможно вы уже сбросили пароль. Если нет, проверьте почту ещё раз'
            })
          }
        }
        window.scrollTo(0, 0);
      })
      .catch(err => {
        console.log(err)
      })
  }
);

export const downloadSchoolList = () => (
  (dispatch) => {
    fetch('/api/schools-dictionary.json')
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          dispatch({
            type: 'SCHOOL_LIST',
            schoolList: json.schoolViewList
          });
        }
      })
  }
);

export const downloadInstituteList = () => (
  (dispatch) => {
    fetch('/api/institutes-dictionary.json')
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          dispatch({
            type: 'INSTITUTE_LIST',
            instituteList: json.instituteViewList
          });
        }
      })
  }
);

export const validationFailed = () => (
  (dispatch) => {
    dispatch({type: 'VALIDATION_FAILED'});
  }
);

export const fixServerError = (serverErrors, field) => (
  (dispatch) => {
    delete serverErrors[field];
    dispatch({
      type: 'FIX_SERVER_ERROR',
      serverErrors: serverErrors
    })
  }
);

export const setInitialState = () => (
  (dispatch) => {
    dispatch({type: 'RESET_VALIDATION'});
  }
);



// WEBPACK FOOTER //
// ./src/actions/auth-action.js